import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import { StagingDto, StagingForUpdateDto } from '../dtos/Staging';
import api from '@/utils/httpClient';
import { ApiListResponse, ApiResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';

async function getStaging(episodeId: string) {
  const config: any = { containsPHI: false };
  return api.get(`/api/stagings?filters=episodeId==${episodeId}`, config).then((response) => {
    const parsedResponse = response.data as ApiListResponse<StagingDto>;
    return parsedResponse.data;
  });
}

async function updateStaging(stagingId: string, data: StagingForUpdateDto) {
  const config: any = { containsPHI: false };
  return api
    .put(`/api/stagings/${stagingId}`, data, config)
    .then((response) => (response.data as ApiResponse<StagingDto>).data);
}

async function createStaging(episodeId: string, data: StagingForUpdateDto) {
  const config: any = { containsPHI: false };
  return api
    .post(`/api/stagings?episodeId=${episodeId}`, data, config)
    .then((response) => (response.data as ApiResponse<StagingDto>).data);
}

async function clearStaging(diseaseId: string) {
  const config: any = { containsPHI: false };
  return api
    .delete(`/api/diseases/${diseaseId}/staging`, config)
    .then((response) => (response.data as ApiResponse<StagingDto>).data);
}

export interface UpdateStagingParameters {
	stagingId: string;
	data: StagingForUpdateDto;
}

export interface CreateStagingParameters {
	diseaseId: string;
	data: StagingForUpdateDto;
}

function useCreateStaging(
  options?: UseMutationOptions<StagingDto, AxiosError, CreateStagingParameters>
) {
  return useMutation(
    async ({ diseaseId, data }: CreateStagingParameters) => createStaging(diseaseId, data),
    options
  );
}

function useUpdateStaging(
  options?: UseMutationOptions<StagingDto, AxiosError, UpdateStagingParameters>
) {
  return useMutation(
    async ({ stagingId, data }: UpdateStagingParameters) => updateStaging(stagingId, data),
    options
  );
}

function useResetStaging(options?: UseMutationOptions<StagingDto, AxiosError, string>) {
  return useMutation(async (id: string) => clearStaging(id), options);
}

export {
  getStaging,
  useUpdateStaging,
  updateStaging,
  useCreateStaging,
  createStaging,
  useResetStaging,
  clearStaging
};
